module.exports = __webpack_public_path__ + "assets/img/00087.89971d7e.png";